import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ComingSoonToast = ({ message, isVisible }) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        initial={{ opacity: 0, x: '-50%', y: 16 }}
        animate={{ opacity: 1, x: '-50%', y: 0 }}
        exit={{ opacity: 0, x: '-50%', y: 8 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        style={{
          position: 'fixed',
          bottom: 28,
          left: '50%',
          backgroundColor: '#2a261f',
          color: '#efe7d6',
          padding: '12px 24px',
          borderRadius: 12,
          boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
          zIndex: 9999,
          fontSize: 14,
          fontWeight: 500,
          letterSpacing: '-0.01em',
          whiteSpace: 'nowrap',
          fontFamily: 'var(--font-sans)',
        }}
      >
        {message}
      </motion.div>
    )}
  </AnimatePresence>
);

export default ComingSoonToast;
